import { render, staticRenderFns } from "./DirectorySwitcher.vue?vue&type=template&id=7c877734"
import script from "./DirectorySwitcher.vue?vue&type=script&lang=js"
export * from "./DirectorySwitcher.vue?vue&type=script&lang=js"
import style0 from "./DirectorySwitcher.vue?vue&type=style&index=0&id=7c877734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports